import { useMemo } from 'react';
import {
  generateBasicColumn,
  IDataGridConfig,
  generateGlobalColumns,
  generateComponentColumn,
  Button,
  Icon,
} from '@ts/storybook';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { CRole, IConfigComponent } from '@ts/ui-models';
import { postChangeRole } from '@services/ApiService';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { useAppDispatch, useAppSelector } from '@redux/store';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';

interface IMyRolesProps {
  configComponent?: IConfigComponent;
}

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    componentId: 'myRoles',
    aclId: 'taXUsersRoles',
    fetchURL: '/api/v2/myRoles',
    mainClass: CRole,
  };
};

const MyRoles = (props: IMyRolesProps) => {
  const { configComponent = defaultConfigComponent() } = props;
  const dispatch = useAppDispatch();
  const badge = useAppSelector(state => state.global.sessionBadge);

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
    widthColumns: { organization: 200, name: 200, Change: 400 },
  };

  //#region Functions
  /*   const extraActions = (): IAction[] => [
    {
      id: 'changeRole',
      label: 'Change role',
      icon: 'change_circle',
      onClick: changeRole,
    },
  ]; */

  const changeRole = async args => {
    const { logicalId: roleId, organization } = args();
    const organizationId = organization.logicalId;
    const userId = badge?.userId;
    if (userId && roleId && organizationId) postChangeRole(dispatch, userId, roleId, organizationId);
    else dispatch(globalActions.updateGlobalState({ key: 'notification', value: 'Cannot change role' }));
  };
  //#endregion

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      generateBasicColumn({ field: 'organization', headerName: 'Organization' }, { field: 'organization.name' }),
      generateBasicColumn({ field: 'name', headerName: 'Role name / ID' }, { field: 'name' }),
      generateComponentColumn(
        (params: GridRenderCellParams) => (
          <Button
            fullWidth
            label={'Change role'}
            endIcon={<Icon icon="change_circle" />}
            onClick={() => changeRole(() => params.row)}
            variant="outlined"
          />
        ),
        { field: 'Change', headerName: '' },
        { field: 'myself' }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      withoutDefaultActions
      //extraActions={extraActions()}
    />
  );
};

export default MyRoles;
